import { QUERY_ELIGIBILITY_SUCCESS, QUERY_ELIGIBILITY_ERROR } from '../constants/actionTypes';
import { changedResponse } from '../constants/eligibilityMessage';

export const initialState = null;

const eligibility = (state = initialState, action) => {
  const { type, payload } = action;

  if (type === QUERY_ELIGIBILITY_SUCCESS) {
    const { status, code } = payload;

    if (status !== 'eligible') {
      let newReason = changedResponse.plan;
      switch (code) {
        case 'domestic_lending':
          newReason = changedResponse.domestic_lending;
          break;
        case 'part_time':
          newReason = changedResponse.part_time;
          break;
        case 'school':
          newReason = changedResponse.school;
          break;
      }

      return {
        ...payload,
        formattedReason: newReason,
      };
    } else return payload;
  }

  if (type === QUERY_ELIGIBILITY_ERROR) {
    return initialState;
  }

  return state;
};

export default eligibility;
